// utils/newrelic-utils.ts
import { BrowserAgent } from "@newrelic/browser-agent";

const initializeNewRelic = () => {
  const licenseKey = window.STUDENT_ENV?.REACT_APP_NEW_RELIC_LICENSE_KEY;
  const applicationID = window.STUDENT_ENV?.REACT_APP_NEW_RELIC_APPLICATION_ID;

  const config = {
    info: {
      licenseKey,
      applicationID,
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      sa: 1
    },
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ["bam.nr-data.net"] }
    }
  };

  if (config.info.licenseKey && config.info.applicationID) {
    try {
      new BrowserAgent(config);
      return true;
    } catch (error) {
      return false;
    }
  }
  return false;
};

// Initialize once
const isNewRelicInitialized = initializeNewRelic();

// Utility function to safely report errors to New Relic
export const reportError = (error: Error | string, customAttributes?: Record<string, unknown>) => {
  try {
    if (window.newrelic && typeof window.newrelic.noticeError === "function") {
      const errorObj = typeof error === "string" ? new Error(error) : error;

      if (customAttributes) {
        window.newrelic.noticeError(errorObj, customAttributes);
      } else {
        window.newrelic.noticeError(errorObj);
      }
    }
  } catch (err) {
    console.error("Failed to report error to New Relic:", err);
    console.error("Original error:", error);
  }
};

// Utility function to safely set user ID
export const setNewRelicUserId = (userId: string) => {
  try {
    if (window.newrelic && typeof window.newrelic.setUserId === "function") {
      window.newrelic.setUserId(userId);
    }
  } catch (err) {
    console.error("Failed to set user ID in New Relic:", err);
  }
};

// Check if New Relic is available
export const isNewRelicAvailable = (): boolean =>
  !!(window.newrelic && typeof window.newrelic.noticeError === "function");

// Export initialization status
export { isNewRelicInitialized };
